import { AfterViewInit, Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { element } from 'protractor';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import * as xlsx from 'xlsx';
import { Router } from '@angular/router';

export interface EmployeeList {
  item: string;
  category: string;
  preferredsupplier: string;
  cyberinfopvtltd: string;
  acminerals: string;
  dpsupplier1: string
}

export interface subCategory {
  sid: number;
  snm: string;
}

export interface category {
  cid: number;
  cnm: string;
  sub: any[];
}

const ELEMENT_DATA: EmployeeList[] = [
  {
    item: '0.37 GAL. FINE WIRE', category: 'ABC', preferredsupplier: 'Water minerals	',
    cyberinfopvtltd: 'Water', acminerals: 'AC', dpsupplier1: 'Fridge'
  },
  {
    item: '0.37 GAL. FINE WIRE', category: 'ABCDE', preferredsupplier: 'AC minerals	',
    cyberinfopvtltd: 'AC', acminerals: 'Fridge', dpsupplier1: 'Water'
  },

  {
    item: '0.37 GAL. FINE WIRE', category: 'ABCDE', preferredsupplier: 'AC minerals	',
    cyberinfopvtltd: 'Fridge', acminerals: 'Water', dpsupplier1: 'AC'
  },
  {
    item: '0.37 GAL. FINE WIRE', category: 'ABC', preferredsupplier: 'Water minerals	',
    cyberinfopvtltd: 'Water', acminerals: 'AC', dpsupplier1: 'Fridge'
  },
  {
    item: '0.37 GAL. FINE WIRE', category: 'ABCDE', preferredsupplier: 'AC minerals	',
    cyberinfopvtltd: 'AC', acminerals: 'Fridge', dpsupplier1: 'Water'
  },

  {
    item: '0.37 GAL. FINE WIRE', category: 'ABCDE', preferredsupplier: 'AC minerals	',
    cyberinfopvtltd: 'Fridge', acminerals: 'Water', dpsupplier1: 'AC'
  },
  {
    item: '0.37 GAL. FINE WIRE', category: 'ABC', preferredsupplier: 'Water minerals	',
    cyberinfopvtltd: 'Water', acminerals: 'AC', dpsupplier1: 'Fridge'
  },
  {
    item: '0.37 GAL. FINE WIRE', category: 'ABCDE', preferredsupplier: 'AC minerals	',
    cyberinfopvtltd: 'AC', acminerals: 'Fridge', dpsupplier1: 'Water'
  },

  {
    item: '0.37 GAL. FINE WIRE', category: 'ABCDE', preferredsupplier: 'AC minerals	',
    cyberinfopvtltd: 'Fridge', acminerals: 'Water', dpsupplier1: 'AC'
  },
  {
    item: '0.37 GAL. FINE WIRE', category: 'ABC', preferredsupplier: 'Water minerals	',
    cyberinfopvtltd: 'Water', acminerals: 'AC', dpsupplier1: 'Fridge'
  },
  {
    item: '0.37 GAL. FINE WIRE', category: 'ABCDE', preferredsupplier: 'AC minerals	',
    cyberinfopvtltd: 'AC', acminerals: 'Fridge', dpsupplier1: 'Water'
  },

  {
    item: '0.37 GAL. FINE WIRE', category: 'ABCDE', preferredsupplier: 'AC minerals	',
    cyberinfopvtltd: 'Fridge', acminerals: 'Water', dpsupplier1: 'AC'
  },
];

@Component({
  selector: 'app-supplier-comparison',
  templateUrl: './supplier-comparison.component.html',
  styleUrls: ['./supplier-comparison.component.scss']
})
export class SupplierComparisonComponent implements OnInit {
  displayedColumns: string[] = ['item', 'category', 'preferredsupplier', 'cyberinfopvtltd', 'acminerals', 'dpsupplier1'];
  dataSource = new MatTableDataSource<EmployeeList>(ELEMENT_DATA);
  // storeList: store[] = [];
  subCategoryList: subCategory[] = [];
  categories: category[] = [];

  // StoreCtrl = new FormControl();
  subCategoryCtrl = new FormControl();

  // filterStore!: Observable<store[]>;
  filteredsubCategoryList!: Observable<subCategory[]>;
  filteredCategory!: Observable<category[]>;

  myControl = new FormControl();
  options: string[] = ['Abc', 'XyzSSS', 'Three'];
  month: string[] = ['may 2019', 'june 2010', 'feb 2021']
  filteredOptions: Observable<string[]> | undefined;

  @ViewChild('epltable', { static: false }) epltable!: ElementRef;
  @ViewChild(MatSort) sort!: MatSort;


  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  item: any;

  constructor(private router: Router) {
  }

  data: any = {
    ItemName: '',
    ItemID: 0,
    code: '',
    typeID: 1,
    categoryID: 0,
    subCategory: '',
    SubCategoryID: 0,
    category: '',
    Qty: '',
    Unit: 'no.s',
    purchaseCost: '',
    salePrice: '',
    stockRate: '',
    minStockQty: '',
    isAvailable: true,
    showOnline: true,
    isActive: true,
    importanceID: 1,
    HSN: '',
    HSNId: 0,
    brochureLink: '',
    fileLink: '',
    description: '',
    tag: '',
    leadTime: '',
    prcn: 0,
    storeName: '',
    storeID: '',
    IsMade: false,
    IsPurchased: false

  }

  store: any;

  ngOnInit() {
    this.dataSource.sort = this.sort;
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }

  exportToExcel() {
    const ws: xlsx.WorkSheet =
      xlsx.utils.table_to_sheet(this.epltable.nativeElement);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();

    xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
    xlsx.writeFile(wb, 'Stock.xlsx');
  }

  // selectStore = () => {
  //  
  //   let tempStore = this.storeList.filter((x: any) => x.sNm == this.data.storeName);
  //   if (tempStore.length > 0) {
  //     this.data.storeID = tempStore[0].StrID
  //   }
  //   else {
  //     this.data.storeID = 0;
  //     this.data.storeName = ""
  //   }
  // }

  // private _filterStore(value: string): store[] {
  //   const filterValue = value.toLowerCase();
  //   return this.storeList.filter(state => state.sNm.toLowerCase().indexOf(filterValue) === 0);
  // }


  selectCategory = () => {
    this.subCategoryList = [];
    if (this.data.category) {
      let tempCat = this.categories.filter((x: any) => x.cnm == this.data.category)
      if (tempCat.length > 0) {
        this.data.categoryID = tempCat[0].cid
        this.subCategoryList = tempCat[0].sub

        this.filteredsubCategoryList = this.subCategoryCtrl.valueChanges
          .pipe(
            startWith(''),
            map(employee => employee ? this._filterSubcategory(employee) : this.subCategoryList.slice())
          );


      } else {
        alert("Please configure category.")
        this.data.category = '';
        this.subCategoryList = [];
        this.data.subCategory = '';
      }

    }
  }

  private _filterSubcategory(value: string): subCategory[] {
    const filterValue = value.toLowerCase();
    return this.subCategoryList.filter(state => state.snm.toLowerCase().indexOf(filterValue) === 0);
  }

  backBtn() {
    this.router.navigate(['/Stock']);
  }
}
